import HttpClient from "./HttpClient";
import Helper from "./Helper";

export default class Structure {
  constructor(structure) {
    this.id = structure.id;
    this.layer_1 = structure.layer_1;
    this.layer_2 = structure.layer_2;
    this.layer_3 = structure.layer_3;
    this.pallet_id = structure.pallet_id;
    this.created_at = structure.created_at;
    this.updated_at = structure.updated_at;
  }

  async save(data){
    const client = new HttpClient();
    const response = await client.instance.put(`palletStructures/${this.id}`, data);
    return response.data;
  }

  prepareForViewing(divider) {
    this.viewing_layer_1 = this.getViewingLayer(this.layer_1, divider);
    this.viewing_layer_2 = this.getViewingLayer(this.layer_2, divider);
    this.viewing_layer_3 = this.getViewingLayer(this.layer_3, divider);
    this.divider = divider;
  }

  getViewingLayer(layer, divider) {
    const planks = layer.split(" ");
    let newLayer = `${planks[0]}`;
    planks.forEach((plank, i) => {
      if (i != 0) {
        plank = parseInt(plank) / divider;
        newLayer += ` ${plank}`;
      }
    });
    return newLayer;
  }

  /**
   * draws first layer of the pallet
   * @param ctx
   * @param pallet
   * @param offset
   */
  drawFirstLayer(ctx, pallet, offset) {
    ctx.beginPath();
    const structure = this.viewing_layer_1;
    const originalStructure = this.layer_1;
    const layers = structure.split(" ");
    const originalLayers = originalStructure.split(" ");
    const width = parseInt(layers[1]);
    const originalWidth = parseInt(originalLayers[1]);
    ctx.strokeStyle = "red";
    ctx.fillStyle = "black";
    ctx.font = "70px Arial";
    ctx.textAlign = "center";
    //draw planks
    for (let i = 2; i < layers.length; i++) {
      ctx.lineWidth = 2;
      //draw planks
      ctx.fillStyle = "red";
      ctx.strokeStyle = "black";
      const positionX = parseInt(layers[i]) + offset.left;
      const positionY = offset.top;
      ctx.fillRect(positionX, offset.top, width, pallet.width - 1);
      ctx.strokeRect(positionX, offset.top, width, pallet.width - 1);
      //draw arrows indicating plank position
      ctx.strokeStyle = "red";
      let positionText = originalLayers[i];
      let arrowX1 = positionX - 20;
      let arrowX2 = positionX;
      const arrowY = positionY + pallet.width + 30;
      ctx.lineWidth = 1;
      if (i != 2) {
        arrowX1 += width;
        arrowX2 += width;
        positionText = parseInt(originalLayers[i]) + originalWidth;
        Helper.canvasArrow(ctx, arrowX1, arrowY, arrowX2, arrowY);
      }
      this.drawLine(ctx, arrowX2, arrowY - 10, arrowX2, arrowY + 10);
      // draw text indicating position on plank
      ctx.fillStyle = "black";
      ctx.font = "10px Arial";
      ctx.textAlign = "center";
      ctx.fillText(positionText, (arrowX1 + arrowX2) / 2 - 10, arrowY - 10);
    }
    ctx.closePath();
  }

  /**
   * draws second layer of the pallet
   * @param ctx
   * @param pallet
   * @param offset
   */
  drawSecondLayer(ctx, pallet, offset) {
    ctx.beginPath();
    ctx.fillStyle = "green";
    ctx.strokeStyle = "green";
    const structure = this.viewing_layer_2;
    const originalStructure = this.layer_2;
    const layers = structure.split(" ");
    const originalLayers = originalStructure.split(" ");
    const width = parseInt(layers[1]);
    const originalWidth = parseInt(originalLayers[1]);
    for (let i = 2; i < layers.length; i++) {
      ctx.lineWidth = 2;
      const positionX = offset.left;
      const positionY = parseInt(layers[i]) + offset.top;
      ctx.strokeStyle = "green";
      ctx.fillStyle = "green";
      ctx.fillRect(positionX, positionY, pallet.length - 1, width);
      ctx.strokeRect(positionX, positionY, pallet.length - 1, width);
      //draw position arrows
      let positionText = originalLayers[i];
      const arrowX = offset.left - 20;
      let arrowY1 = positionY - 20;
      let arrowY2 = positionY;
      ctx.lineWidth = 1;
      if (i != 2) {
        arrowY1 += width;
        arrowY2 += width;
        positionText = parseInt(originalLayers[i]) + originalWidth;
        Helper.canvasArrow(ctx, arrowX, arrowY1, arrowX, arrowY2);
      }
      this.drawLine(ctx, arrowX - 10, arrowY2, arrowX + 10, arrowY2);
      //draw position numbers
      ctx.fillStyle = "black";
      ctx.font = "10px Arial";
      ctx.textAlign = "center";
      ctx.fillText(positionText, arrowX - 20, (arrowY1 + arrowY2) / 2);
    }
    ctx.strokeStyle = "green";
    //draw height arrow
    const arrowX = 40;
    Helper.canvasArrow(
      ctx,
      arrowX,
      offset.top,
      arrowX,
      offset.top + pallet.width
    );
    Helper.canvasArrow(
      ctx,
      arrowX,
      offset.top + pallet.width,
      arrowX,
      offset.top
    );
    this.drawVerticalText(
      ctx,
      Math.round(pallet.width * this.divider),
      arrowX - 10,
      (2 * offset.top + pallet.width) / 2,
      -1
    );
    ctx.closePath();
  }

  /**
   * draws third layer of the pallet
   * @param ctx
   * @param pallet
   * @param offset
   */
  drawThirdLayer(ctx, pallet, offset) {
    ctx.beginPath();
    const structure = pallet.pallet_structure.viewing_layer_3;
    const originalStructure = pallet.pallet_structure.layer_3;
    const layers = structure.split(" ");
    const originalLayers = originalStructure.split(" ");
    const width = parseInt(layers[1]);
    const originalWidth = parseInt(originalLayers[1]);
    ctx.fillStyle = "blue";
    for (let i = 2; i < layers.length; i++) {
      ctx.lineWidth = 2;
      //draw planks
      const positionX = parseInt(layers[i]) + offset.left;
      const positionY = offset.top;
      ctx.strokeStyle = "black";
      ctx.fillStyle = "blue";
      ctx.fillRect(positionX, positionY, width, pallet.width - 1);
      ctx.strokeRect(positionX, positionY, width, pallet.width - 1);
      //draw position arrows
      let positionText = originalLayers[i];
      let arrowX1 = positionX - 20;
      let arrowX2 = positionX;
      const arrowY = positionY - 20;
      ctx.lineWidth = 1;
      if (i != 2) {
        arrowX1 += width;
        arrowX2 += width;
        positionText = parseInt(originalLayers[i]) + originalWidth;
        Helper.canvasArrow(ctx, arrowX1, arrowY, arrowX2, arrowY);
      }
      this.drawLine(ctx, arrowX2, arrowY - 10, arrowX2, arrowY + 10);
      // draw text indicating position on plank
      ctx.fillStyle = "black";
      ctx.font = "10px Arial";
      ctx.textAlign = "center";
      ctx.fillText(positionText, (arrowX1 + arrowX2) / 2 - 5, arrowY - 10);
    }
    ctx.strokeStyle = "blue";
    const lineY = 50;
    Helper.canvasArrow(ctx, offset.left, lineY, offset.left + pallet.length, lineY);
    Helper.canvasArrow(ctx, offset.left + pallet.length, lineY, offset.left, lineY);
    ctx.textAlign = "center";
    ctx.font = "10px Arial";
    ctx.fillStyle = "black";
    ctx.fillText(
      Math.round(pallet.length * this.divider),
      (2 * offset.left + pallet.length) / 2,
      lineY - 10
    );
    ctx.closePath();
  }

  drawLine(ctx, x1, y1, x2, y2) {
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
  }

  drawVerticalText(ctx, text, positionX, positionY, invert) {
    //vertical text
    ctx.save();
    ctx.translate(positionX, positionY);
    ctx.rotate((invert * Math.PI) / 2);
    ctx.fillText(text, 0, 0);
    ctx.restore();
  }

  getPalletWeight(pallet){
    const plankHeight = 0.05; //in meters
    const pineDensity = 510; //kg in m3
    //get layer 1 weight
    const layer1Planks = this.layer_1.split(' ');
    const layer1PlanksCount = parseInt(layer1Planks[0]);
    const layer1PlanksWidth = parseInt(layer1Planks[1]) / 1000; //in meters
    const layer1Weight = layer1PlanksCount * plankHeight * layer1PlanksWidth * pallet.width / 1000 * pineDensity;
    //get layer 2 weight
    const layer2Planks = this.layer_2.split(' ');
    const layer2PlanksCount = parseInt(layer2Planks[0]);
    const layer2PlanksWidth = parseInt(layer2Planks[1]) / 1000;
    const layer2Weight = layer2PlanksCount * plankHeight * layer2PlanksWidth * pallet.length / 1000 * pineDensity;
    //get layer 3 weight
    const layer3Planks = this.layer_3.split(' ');
    const layer3PlanksCount = parseInt(layer3Planks[0]);
    const layer3PlanksWidth = parseInt(layer3Planks[1]) / 1000;
    const layer3Weight = layer3PlanksCount * plankHeight * layer3PlanksWidth * pallet.width / 1000 * pineDensity;
    return Math.round((layer1Weight + layer2Weight + layer3Weight) * 1.1);
  }
}
